export default "__VITE_ASSET__wDqNaX_W__"